import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const deviceUserListRoutes = {
  path: 'device-user-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.deviceUser.list'),
  },
  children: [
    {
      path: '',
      name: 'deviceUserList',
      component: () => lazyLoadView(import('@views/DeviceUserList/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
  ],
}

export default deviceUserListRoutes
